export default __webpack_public_path__ + "static/media/young-adult.8cb57131.png";